import React, {useContext} from "react"
import {Panel, DataRow} from "../PDFPrimitives"
import {PDFContext} from "../BasePDF"

export const TradeInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    return (
        <Panel title="Trade Information">
            <DataRow label="Gross Trade (Allowance)" value={pdfData.trade_in_amount.toDollarFormat()} variant="muted"/>
            <DataRow label="Owed Trade (Payoff)"     value={pdfData.trade_payoff.toDollarFormat()}  variant="muted"/>

            <DataRow
                label="Trade Equity (Applied)"
                value={pdfData.trade_equity.toDollarFormat()}
                isTotal
                variant="muted"
                isLast
            />
        </Panel>
    )
}
